export enum actionTypes {
  MODEL = 'MODEL',
  FRAME = 'FRAME',
  TEMPLE = 'TEMPLE',
  LENS = 'LENS',
  LOGO = 'LOGO',
  LENOPTIONS = 'LENOPTIONS',
  BRIDGE = 'BRIDGE',
}

export enum modelTypes {
  FRAME = 'FRAME',
  RIMLESS = 'RIMLESS',
}

export enum frameTypes {
  COLOR = 'COLOR',
  PATTERN = 'PATTERN',
}

export enum lenTypes {
  CLEAR = 'CLEAR',
  ORDINARY = 'ORDINARY',
  FUNCTION = 'FUNCTION',
}

export enum lenOptions {
  NONE = 'none',
  MIRROR = 'mirror_coat',
  LUTINA = 'lutina',
  STRONGEST = 'strongest_coat',
  BDC = 'bdc',
  ESC = 'esc',
}

export enum logoTypes {
  FRONT = 'logoFrontColor',
  BACK = 'logoBackColor',
}

export enum favoriteState {
  ADD_NEW = 'ADD_NEW',
  SELECTED_CHANGE = 'SELECTED_CHANGE',
  CONFIRM_DELETE = 'CONFIRM_DELETE',
  CHANGE_NAME = 'CHANGE_NAME',
  CONFIRM_OVERRIDE = 'CONFIRM_OVERRIDE',
}

export enum GlassOnResponseStatus {
  Success = 200,
}

export const hellooStorage = {
  masterData: 'helloo-defination',
  favorites: 'helloo-favorites',
}
